/**
 * Supabase User Management Repository
 * Calls admin-users edge function for user listing and approval
 */

import type {
  IUserManagementRepository,
  ManagedUser,
} from '../interfaces/IUserManagementRepository'
import { requireSupabaseClient } from '@/lib/supabase'

export class SupabaseUserManagementRepository implements IUserManagementRepository {
  async listUsers(): Promise<ManagedUser[]> {
    const supabase = requireSupabaseClient()
    const {
      data: { session },
    } = await supabase.auth.getSession()

    if (!session) throw new Error('Not authenticated')

    const { data, error } = await supabase.functions.invoke(
      'admin-users?action=list',
      {
        headers: { Authorization: `Bearer ${session.access_token}` },
      }
    )

    if (error) throw new Error(`Failed to list users: ${error.message}`)
    return data?.users || []
  }

  async approveUser(userId: string): Promise<void> {
    const supabase = requireSupabaseClient()
    const {
      data: { session },
    } = await supabase.auth.getSession()

    if (!session) throw new Error('Not authenticated')

    const { error } = await supabase.functions.invoke(
      'admin-users?action=approve',
      {
        body: { userId },
        headers: { Authorization: `Bearer ${session.access_token}` },
      }
    )

    if (error) throw new Error(`Failed to approve user: ${error.message}`)
  }

  async revokeUser(userId: string): Promise<void> {
    const supabase = requireSupabaseClient()
    const {
      data: { session },
    } = await supabase.auth.getSession()

    if (!session) throw new Error('Not authenticated')

    const { error } = await supabase.functions.invoke(
      'admin-users?action=revoke',
      {
        body: { userId },
        headers: { Authorization: `Bearer ${session.access_token}` },
      }
    )

    if (error) throw new Error(`Failed to revoke user: ${error.message}`)
  }
}
